import { useQuery } from '@tanstack/react-query';
import { client } from '../../api';

export const useHasAnyPrescriptions = () => {
  return useQuery({
    queryKey: ['has-any-prescriptions'],
    queryFn: () => client.get('/rxs/has-any').then((res) => res.data.has_any as boolean),
    staleTime: Infinity,
  });
};
